import { CarouselFeature } from "./feature-base.js";
class KeyboardPaging extends CarouselFeature {
  constructor() {
    super(...arguments);
    this.handleFocus = (event) => {
      if (event.type === "focus" && event.target === this.host.scrollContainer) {
        this.host.scrollContainer.classList.add("keyboard-navigation");
      } else {
        this.host.scrollContainer.classList.remove("keyboard-navigation");
      }
    };
  }
  connectedCallback() {
    this.host.scrollContainer.addEventListener("focus", this.handleFocus);
    this.host.scrollContainer.addEventListener("blur", this.handleFocus);
  }
  disconnectedCallback() {
    this.host.scrollContainer.removeEventListener("focus", this.handleFocus);
    this.host.scrollContainer.removeEventListener("blur", this.handleFocus);
  }
}
export {
  KeyboardPaging
};
